import React from "react";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import NavBar from "../components/navbar";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useAuth0 } from "@auth0/auth0-react";
import { List, ListItem, ListItemText } from "@material-ui/core";
import CoursesView from './views/coursesView';
import TalentIdentity from "../components/talentIdentity";

const useStyles = makeStyles((theme) => ({
    list: {
      color: "white",
    },
    listItem: {
      paddingLeft: "50px",
      color: "white"
    },
    verNav: {
      height: "100vh",
      backgroundColor: "#153BAB",
    },
    horNav: {
      backgroundColor: "#153BAB",
    }
}));

const Courses = () => {
    const matches = useMediaQuery("(max-width:599px)");
    const { user } = useAuth0();
    const classes = useStyles();

    return (
    <div>
        <NavBar type="main" />
        <Grid container direction="row" justify="center" alignItems="stretch">
        <Grid item xs={12} sm={4} lg={3}>
            <Grid
            container
            direction="column"
            justify="space-evenly"
            alignItems="center"
            className={matches ? classes.horNav : classes.verNav}
            >
            <TalentIdentity user={user} />
            <Grid
                container
                direction="column"
                alignItems="center"
                className={matches ? classes.posMargin : classes.negMargin}
            >
                <List
                component="nav"
                aria-labelledby="nested-list"
                className={classes.list}
                >
                <ListItem
                    className={classes.listItem}
                    component="a"
                    href="/TalentProfile"
                >
                    <ListItemText primary="Profile" />
                </ListItem>
                <ListItem className={classes.listItem} component="a" href="/assessments">
                    <ListItemText primary="Assessment" />
                </ListItem>
                <ListItem className={classes.listItem} button>
                    <ListItemText primary="Courses" />
                </ListItem>
                </List>
            </Grid>
            </Grid>
        </Grid>
        <Grid item xs={12} sm={8} lg={9}>
            <CoursesView />
        </Grid>
        </Grid>
    </div>
    );
};

export default Courses;
